import {useState} from "react";
import {css} from "@emotion/css";
import {
    DialogSize, RaikoButtonPrimary,
    RaikoDefaultDialogPage, RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoNumberInputOutlined, showErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {SettingService} from "../../serverService/settingService/SettingService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function SettingLoanTypeTableHeader(
    {
        min,
        max,
        id,
        handleUpdateTable
    }
) {

    const service = new SettingService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [openDialog, setOpenDialog] = useState(false)
    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    const [minT, setMinT] = useState(min);
    const [maxT, setMaxT] = useState(max);

    function handleUpdate() {
        loading.show()
        service.updateTableHeader(
            id, minT, maxT
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            handleUpdateTable()
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>

            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"بروزرسانی حدود جدول"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
                    <RaikoNumberInputOutlined labelText={"حد پایین"} value={minT} setValue={setMinT}/>
                    <RaikoNumberInputOutlined labelText={"حد بالا"} value={maxT} setValue={setMaxT}/>
                    <RaikoFlexAlignEnd>
                        <RaikoButtonPrimary label={"بروزرسانی"} onClick={handleUpdate}/>
                    </RaikoFlexAlignEnd>
                </RaikoGridOneColumn>
            </RaikoDefaultDialogPage>
            <span className={css`
              cursor: pointer;
              text-align: center;
              padding: .25rem 1rem;
              transition: all 150ms linear;
              font-weight: 900;

              &:hover {
                color: var(--color-primary);
              }
            `}
                  onClick={handleOpenDialog}
            >
           {`${min} - ${max}`}
        </span>
        </>
    )
}
